import _classCallCheck from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Color } from 'three';
import { Pass } from './Pass.js';
var RenderPass = /*#__PURE__*/function (_Pass) {
  _inherits(RenderPass, _Pass);
  function RenderPass(scene, camera, overrideMaterial, clearColor, clearAlpha) {
    var _this;
    _classCallCheck(this, RenderPass);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RenderPass).call(this));
    _this.scene = scene;
    _this.camera = camera;
    _this.overrideMaterial = overrideMaterial;
    _this.clearColor = clearColor;
    _this.clearAlpha = clearAlpha !== undefined ? clearAlpha : 0;
    _this.clear = true;
    _this.clearDepth = false;
    _this.needsSwap = false;
    _this._oldClearColor = new Color();
    return _this;
  }
  _createClass(RenderPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */) {
      var oldAutoClear = renderer.autoClear;
      renderer.autoClear = false;
      var oldClearAlpha, oldOverrideMaterial;
      if (this.overrideMaterial !== undefined) {
        oldOverrideMaterial = this.scene.overrideMaterial;
        this.scene.overrideMaterial = this.overrideMaterial;
      }
      if (this.clearColor) {
        renderer.getClearColor(this._oldClearColor);
        oldClearAlpha = renderer.getClearAlpha();
        renderer.setClearColor(this.clearColor, this.clearAlpha);
      }
      if (this.clearDepth) {
        renderer.clearDepth();
      }
      renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);

      // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
      if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
      renderer.render(this.scene, this.camera);
      if (this.clearColor) {
        renderer.setClearColor(this._oldClearColor, oldClearAlpha);
      }
      if (this.overrideMaterial !== undefined) {
        this.scene.overrideMaterial = oldOverrideMaterial;
      }
      renderer.autoClear = oldAutoClear;
    }
  }]);
  return RenderPass;
}(Pass);
export { RenderPass };